import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { languages } from "../../constants/languages";
import DialogContentText from "@material-ui/core/DialogContentText";

export default class AlreadyDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>{languages.schedule.planAgain}</DialogTitle>
        <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
          <DialogContentText>
            {languages.schedule.alreadyPlannedMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.handleClose} color="primary">
            {languages.general.cancel}
          </Button>
          <Button
            onClick={this.props.divideMatches}
            variant="contained"
            color="primary"
            type="submit"
            disabled={this.props.dividing}
          >
            {languages.schedule.plan}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
